import { Controller } from '@hotwired/stimulus';

export default class ResponseQuestionCardController extends Controller {
  static targets = [
    'responseInput',
    'submitButton',
    'placeholderText',
    'inputCounter',
    'successMessage'
  ];
  limitWarningThreshold = 250;
  limitDangerThreshold = 50;
  inputMaxLength = 0;
  isHiddenClass = 'is-hidden';
  counterDangerClass = 'ActionItemCard-answerCounter--danger';
  // bind returns a new handler. This enables you to add and remove the listener.
  boundHideSuccessMessage = null;

  connect() {
    this.inputMaxLength = this.responseInputTarget.maxLength;
    this.submitButtonTarget.disabled = true;
    this.boundHideSuccessMessage = this.hideSuccessMessage.bind(this);
    this.responseInputTarget.focus();
    this.processCardState();
  }

  onInputKeyUp() {
    this.processCardState();
  }

  processCardState() {
    this.togglePlaceholderText();
    this.toggleSubmitButton();
    this.processCharacterLimit();
    this.resizeInput();
  }

  onSaveSuccess(data) {
    const payload = data.detail[0];
    if (payload.status === 200) {
      const event = new CustomEvent('actionItemCard.saveSuccess', {
        detail: payload
      });
      document.dispatchEvent(event);

      this.showSuccessMessage();
    }
  }

  /* *** "Private" Methods Below *** */

  showSuccessMessage() {
    this.successMessageTarget.addEventListener(
      'animationend',
      this.boundHideSuccessMessage,
      false
    );
    this.successMessageTarget.classList.remove('u-hide');
    this.successMessageTarget.classList.add('u-show');
  }

  hideSuccessMessage() {
    this.successMessageTarget.classList.remove('u-show');
    this.successMessageTarget.classList.add('u-hide');
    this.successMessageTarget.removeEventListener(
      'animationend',
      this.boundHideSuccessMessage,
      false
    );
  }

  togglePlaceholderText() {
    if (this.isFormValid()) {
      this.placeholderTextTarget.classList.add(this.isHiddenClass);
    } else {
      this.placeholderTextTarget.classList.remove(this.isHiddenClass);
    }
  }

  toggleSubmitButton() {
    this.submitButtonTarget.disabled = !this.isFormValid();
  }

  processCharacterLimit() {
    this.updateCharacterCounter();
    this.toggleCharacterCounterVisibility();
  }

  resizeInput() {
    const calculatedHeight = this.calculateNewInputHeight();
    this.responseInputTarget.style.height = `${calculatedHeight / 16}rem`;
  }

  updateCharacterCounter() {
    this.inputCounterTarget.innerHTML = this.charactersLeft();
  }

  toggleCharacterCounterVisibility() {
    if (this.characterThresholdReached()) {
      this.inputCounterTarget.classList.remove(this.isHiddenClass);
    } else {
      this.inputCounterTarget.classList.add(this.isHiddenClass);
    }

    if (this.charactersLeft() < this.limitDangerThreshold) {
      this.inputCounterTarget.classList.add(this.counterDangerClass);
    } else {
      this.inputCounterTarget.classList.remove(this.counterDangerClass);
    }
  }

  calculateNewInputHeight() {
    this.responseInputTarget.style.height = 'inherit';
    return this.responseInputTarget.scrollHeight + 2;
  }

  charactersLeft() {
    return this.inputMaxLength - this.responseInputTarget.value.length;
  }

  characterThresholdReached() {
    return this.charactersLeft() <= this.limitWarningThreshold;
  }

  isFormValid() {
    return this.responseInputTarget.value !== '';
  }
}
